module.exports = __webpack_public_path__ + "media/images/number_7_green-3bfe30f32d3b6c4dbddb6d5d13621401.png";